import React from 'react';
import Header from "../components/Header";
import Footer from "../components/footer";

const InitiativePage = () => {
    return (
        <div className="bg-gray-100 text-gray-900">
            {/* Header Section */}
            <Header/>



            {/* About Section */}
            <section className="py-16 px-4 mt-20">
                <div className="max-w-5xl mx-auto ">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-center">CSTCloud - AOSP EA</h2>
                    <p className="text-lg md:text-xl text-gray-700 leading-7">
                        Through a partnership outlined in the MoU between GOSC IPO and the African Institute for Capacity Development (AICAD), the China-Africa Cloud Federation is taking meaningful steps to promote open science in Eastern Africa. This includes driving initiatives through the Africa Open Science Platform Eastern Africa Node (AOSP EA Node), hosted at AICAD, and establishing a GOSC regional node in Kenya. These efforts aim to support the monitoring, prediction, and decision-making needed for sustainable implementation of the UN Sustainable Development Goals (SDGs) in the region.
                        The collaboration is designed to enhance regional cooperation by improving network connectivity, infrastructure access, and the sharing of data, tools, and expertise across the GOSC community. Beyond this, the partnership aspires to create a lasting global impact on the open science movement, fostering innovative, sustainable solutions to common challenges, with a particular focus on achieving the SDGs and more.
                    </p>
                    <p className="mt-4">
                        <a href="https://goscloud.net/CSTAOSPEA"
                           className="text-lg text-blue-600 md:text-xl cursor-pointer leading-relaxed text-center mt-8 hover:border-2 hover:p-2 hover:border-green-600">
                            Read More
                        </a>
                    </p>

                </div>
            </section>

            {/* Partners Section */}
            <section className="bg-gray-200 py-16 px-4">
                <div className="max-w-5xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="bg-white shadow-lg p-6 rounded-lg">
                            <img src="https://aospea.org/cstcloud.png"/>
                        </div>
                        <div className="bg-white shadow-lg p-6 rounded-lg">
                            <img src="https://aospea.org/gosc.png"/>
                        </div>
                        <div className="bg-white shadow-lg p-6 rounded-lg">
                            <img src="https://aospea.org/aosp-web-logo.png"/>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </div>
    );
};

export default InitiativePage;
